define('../app/fukit/behavior/named.state.behavior',['require','exports','module','underscore','datakit/datakit','appkit/util/key.prefixer','marionette','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      DataKit     = require('datakit/datakit'),
      KeyPrefixer = require('appkit/util/key.prefixer'),
      Mn          = require('marionette'),
      Radio       = require('backbone.radio');

  var NamedState = DataKit.Model.extend({
    options: {
      defaultIndex: 0,
    },

    getOption: Mn.proxyGetOption,

    initialize: function(attrs, options) {
      this.options = _.extend({}, _.result(this, 'options'), options);
    },
  });

  var SelectableState = NamedState.extend({
    initialize: function() {
      NamedState.prototype.initialize.apply(this, arguments);

      this.setupProxyForSelectedModelEvents();

      this.on('change:selectedModel', function() {
        this.setupProxyForSelectedModelEvents();
      });
    },

    setupProxyForSelectedModelEvents: function() {
      if (this.previous('selectedModel')) {
        this.stopListening(this.previous('selectedModel'));
      }
      this.listenTo(this.get('selectedModel'), 'all', function() {
        //prettier-ignore
        var eventName = arguments[0],
            args = _.toArray(arguments);
        args[0] = 'selectedModel:' + eventName;
        this.trigger.apply(this, args);
      });
    },

    setSelectedModel: function(model) {
      this.set('selectedModel', model);
    },

    getSelectedModel: function() {
      return this.get('selectedModel');
    },

    getCollection: function() {
      return this.get('selectableCollection');
    },

    insertNewModel: function() {
      //prettier-ignore
      var selectableCollection = this.get('selectableCollection'),
          newModel = this.getOption('newModelDefaults');
      var newSelectedModel = selectableCollection.add(newModel, { at: this.getOption('defaultIndex') });
      this.setSelectedModel(newSelectedModel);
    },
  });

  var NamedStateBehavior = Mn.Behavior.extend({
    defaults: {
      states: {
        main: {
          // when true, allows for selectable options,
          // which allow to setup a collection with selected
          // item in it.
          isSelectable: false,
          selectableOptions: {
            collection: null,
            newModelDefaults: {},
            defaultIndex: 0,
          },
        },
      },
    },

    // setup states on initialize, so that they are available immediately
    initialize: function() {
      var states = this.getOption('states');
      this._namedStates = {};

      _.each(
        states,
        function(stateOptions, name) {
          this.createStateAndReference(name, Mn._getValue(stateOptions, this));
        },
        this
      );

      this.addGetStateFunctionToView();
    },

    createStateAndReference: function(name, stateOptions) {
      var modelClass = stateOptions.modelClass;
      if (stateOptions.isSelectable) {
        var namedState = new (modelClass || SelectableState)(
          {
            selectableCollection: null,
            selectedModel: null,
          },
          stateOptions
        );

        this.once('before:render', function() {
          this.setupSelectableCollectionState(stateOptions, namedState);
        });

        this._namedStates[name] = namedState;
      } else {
        this._namedStates[name] = new (modelClass || NamedState)({}, stateOptions);
      }
    },

    addGetStateFunctionToView: function() {
      var self = this;
      this.view.getState = function(name) {
        if (_.isString(name)) {
          return self._namedStates[name];
        } else {
          return null;
        }
      };
    },

    setupSelectableCollectionState: function(stateOptions, selectableState) {
      this.resolveNewModelDefaults(selectableState);

      //prettier-ignore
      var usingViewCollection = false,
          selectableCollection = stateOptions['selectableCollection'];

      if (!selectableCollection) {
        selectableCollection = this.view.collection;
        usingViewCollection = true;
      }

      if (!selectableCollection || !(selectableCollection instanceof DataKit.Collection)) {
        selectableCollection = new DataKit.Collection();
      }

      this.setupSelectableCollectionWhenFetched(selectableState, selectableCollection);

      if (usingViewCollection) {
        this.listenTo(this.view, 'change:collection', function() {
          var selectableCollection = this.view.collection;
          this.setupSelectableCollectionWhenFetched(selectableState, selectableCollection);
        });
      }
    },

    resolveNewModelDefaults: function(selectableState) {
      if (selectableState && selectableState.options) {
        selectableState.options['newModelDefaults'] = this.resolveModelAndStateOptions(
          selectableState.options['newModelDefaults'],
          this.view.model
        );
      }
    },

    setupSelectableCollectionWhenFetched: function(selectableState, selectableCollection) {
      if (selectableCollection.fetched) {
        this.setupSelectableCollection(selectableState, selectableCollection);
      } else {
        this.listenTo(selectableCollection, 'sync', function() {
          this.setupSelectableCollection(selectableState, selectableCollection);
        });
      }
    },

    setupSelectableCollection: function(selectableState, selectableCollection) {
      var previousSelectableCollection = selectableState.get('selectableCollection');

      selectableState.set('selectableCollection', selectableCollection);

      if (selectableCollection.isEmpty()) {
        selectableState.insertNewModel();
      }

      if (!selectableState.getSelectedModel() && !selectableCollection.isEmpty()) {
        selectableState.setSelectedModel(selectableCollection.at(selectableState.getOption('defaultIndex')));
      }

      var debouncedSetSelection = _.debounce(function() {
        if (selectableCollection.isEmpty()) {
          selectableState.setSelectedModel(null);
        } else {
          selectableState.setSelectedModel(selectableCollection.at(selectableState.getOption('defaultIndex')));
        }
      });

      var addCallback = function(addedModel) {
        if (!selectableState.getSelectedModel()) {
          debouncedSetSelection();
        }
      };

      var removeCallback = function(removedModel) {
        if (selectableState.getSelectedModel() == removedModel) {
          debouncedSetSelection();
        }
      };

      if (previousSelectableCollection) {
        this.stopListening(previousSelectableCollection, 'add', addCallback).stopListening(
          previousSelectableCollection,
          'remove',
          removeCallback
        );
      }

      this.listenTo(selectableCollection, 'remove', removeCallback).listenTo(selectableCollection, 'add', addCallback);

      selectableState.trigger('completeSetup');
    },

    resolveModelAndStateOptions: function(options, model) {
      var state = Radio.channel('AppKit.controllerService').request('state');

      return KeyPrefixer.resolve(options, {
        '@state.': function(stateKey) {
          if (state) {
            return state.get(stateKey);
          }
        },
        '@model.': function(modelKey) {
          if (model) {
            return model.get(modelKey);
          }
        },
      });
    },
  });
  NamedStateBehavior.NamedState = NamedState;
  NamedStateBehavior.SelectableState = SelectableState;
  module.exports = NamedStateBehavior;
});

